import { Component, Input } from '@angular/core';

/**
 * Componente de tarjeta numérica reutilizable para mostrar estadísticas
 * con título, subtítulo, icono y valor numérico.
 */
@Component({
  selector: 'app-tarjeta-numerica',
  templateUrl: './tarjeta-numerica.component.html',
  styleUrls: ['./tarjeta-numerica.component.scss'],
  standalone: false
})
export class TarjetaNumericaComponent {
  private static contadorId = 0;
  public idUnico: string;

  /** Título principal de la tarjeta */
  @Input() titulo: string = '';

  /** Subtítulo o descripción adicional */
  @Input() subtitulo: string = '';

  /** Nombre del icono de Ionicons a mostrar */
  @Input() icono: string = 'stats-chart-outline';

  /** Color del icono (primary, success, warning, danger, etc.) */
  @Input() colorIcono: string = 'primary';

  /** Color personalizado en hex para el icono (prioritario sobre colorIcono) */
  @Input() colorIconoCustom?: string;

  /** Valor numérico o string formateado a mostrar */
  @Input() valor: number | string = 0;

  /** Indica si los datos están cargando */
  @Input() cargando: boolean = false;

  /** Texto de información que se mostrará en un popover */
  @Input() informacion: string = '';

  /** Sufijo para el valor (ej: %, kg, etc) */
  @Input() sufijo: string = '';

  constructor() {
    this.idUnico = `informacion-tarjeta-${TarjetaNumericaComponent.contadorId++}`;
  }
}
